import React, { FunctionComponent } from 'react'
import CloseIcon from 'transfix-icons/build/CloseIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { InlineMessage, InlineMessageProps } from 'transfix-ui/components/InlineMessage'
import { DialogTitle as MuiDialogTitle } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import { makeStyles } from 'transfix-ui/core/styles'
import { DialogHeader } from './DialogHeader'

const useDialogTitleStyles = makeStyles(theme => ({
  root: {
    margin: '0',
    padding: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
  },
  titleContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
}))

interface DialogTitleProps {
  children: React.ReactNode
  inlineMessageProps?: InlineMessageProps
  onClose: () => void
}

export const DialogTitle: FunctionComponent<DialogTitleProps> = ({
  children,
  inlineMessageProps,
  onClose,
}) => {
  const classes = useDialogTitleStyles()
  const { cta, dataTest: messageDataTest, fullWidth, message, type } = inlineMessageProps || {}
  return (
    <MuiDialogTitle className={classes.root}>
      <Box className={classes.titleContainer}>
        <Box ml={1} mr={2} display='flex' alignItems='center'>
          <DialogHeader>{children}</DialogHeader>
        </Box>
        {inlineMessageProps && (
          <InlineMessage
            message={message || ''}
            type={type}
            cta={cta}
            dataTest={messageDataTest}
            fullWidth={fullWidth}
          />
        )}
      </Box>
      <Box>
        {onClose ? (
          <IconButton
            onClick={onClose}
            color='tertiary'
            Icon={CloseIcon}
            label='Close Modal'
            size='large'
          />
        ) : undefined}
      </Box>
    </MuiDialogTitle>
  )
}
